"use strict";

define('view/report/report.columns',['jquery', 'marionette', 'underscore', 'backbone', 'uikit/uikit', 'sortable/sortable.mixin', '../../templates'], function ($, Mn, _, Backbone, UIKit, SortableMixin, Templates) {
  function reportColumnTypeColor(type) {
    switch (type) {
      case 'study':
        return 'blue';
      case 'audit':
        return 'green';
    }
  }
  var ReportColumn = UIKit.ItemView.extend({
    className: 'ui segment',
    template: Templates.IRB['report.column'],
    options: {
      text: ''
    },
    bindings: {
      'text': 'displayName'
    },
    internalViewOptions: function internalViewOptions() {
      var columnTypeColor = this.model.get('type') ? reportColumnTypeColor(this.model.get('type').name) : '';
      return {
        columnType: {
          color: columnTypeColor
        },
        columnOptions: {
          basic: true,
          childBindings: {
            text: 'text',
            disabled: 'disabled'
          },
          circular: true,
          collection: new Backbone.Collection([{
            text: 'Move Up',
            action: 'moveUp'
          }, {
            text: 'Move Down',
            action: 'moveDown'
          }, {
            text: 'Remove',
            action: 'remove'
          }]),
          color: 'white',
          icon: 'ellipsis horizontal',
          iconOnly: 'true',
          mode: 'button',
          pointing: 'right',
          ariaLabel: 'manage report field',
          childViewOptions: function childViewOptions(actionModel, positionIndex) {
            return {
              dropdownView: this,
              isButton: true
            };
          }
        }
      };
    },
    onRender: function onRender() {
      this.columnType.text = this.model.get('type').description;
    }
  });
  var EmptyReportColumn = UIKit.Text.extend({
    options: {
      text: 'Add a column from the list of available report columns.'
    },
    attributes: {
      style: 'opacity: 0.7'
    }
  });
  var ReportColumns = Mn.CollectionView.extend(SortableMixin).extend({
    childView: ReportColumn,
    emptyView: EmptyReportColumn,
    initialize: function initialize() {
      this.listenTo(this, 'add:child remove:child', _.debounce(this.updateFieldActions));
      this.initializeSortable();
    },
    onRemoveChild: function onRemoveChild(childView) {
      document.documentElement.style.cursor = '';
    },
    updateFieldActions: function updateFieldActions() {
      var children = this.children;
      if (!this.collection.isEmpty()) {
        children.each(function (c) {
          c.columnOptions.collection.at(0).set('disabled', c._index == 0);
          c.columnOptions.collection.at(1).set('disabled', c._index == children.length - 1);
        });
      }
    }
  });
  return ReportColumns;
});

